<template>
 <div>
  <div class="detailsTitle" >
       <h4>查看报价</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120" v-if="jiedanFlag!=1">
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="scope.row.status==1101||(scope.row.status==1202&&jiedanFlag!=1)"  @click="zhidingFn(scope.row)">指定接单</el-button>
            </template>
        </el-table-column>
        <el-table-column property="status" label="接单状态" :formatter="statusFormat"></el-table-column>
        <el-table-column prop="tenantName"  min-width="200" :formatter="emptyFn" label="公司名称"></el-table-column>
        <el-table-column property="pricingMethod" width="110" label="计价方式" >
          <template scope="scope">
            {{[ "按吨", "包船" ][scope.row.pricingMethod-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" width="150" :formatter="emptyFn" label="运费价格"></el-table-column>
        <el-table-column prop="taxPrice" width="150" :formatter="emptyFn" label="含税价格"></el-table-column>
        <el-table-column prop="dealDuration" width="120" :formatter="emptyFn" label="合约时长(天)"></el-table-column>
        <el-table-column prop="demurrageRate"  min-width="200" :formatter="emptyFn" label="滞期费率(元/吨天)"></el-table-column>
        <el-table-column prop="shipName" width="150" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="shipDateNo" width="150" :formatter="emptyFn" label="航次号"></el-table-column>
        <el-table-column prop="referenceCapacity" width="150" :formatter="emptyFn" label="船舶载重(吨)"></el-table-column>
        <el-table-column prop="quoteUserName" width="120" :formatter="emptyFn" label="报价人"></el-table-column>
        <el-table-column prop="quoteTime" width="170" :formatter="dateTimeFormat"  label="报价时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { flowOffList, appointFlow } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    let id = this.$route.query.id
    let jiedanFlag = this.$route.query.jiedanFlag// 1已有公司接单，2没有公司接单
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        flowId: id
      },
      jiedanFlag: jiedanFlag,
      total: 0,
      btnIdArr: ['00KP004B001', '00KP004B002', '00KP004B003', '00KP004B004']
    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 138) + 'px'
  },
  methods: {
    // 指定接单
    zhidingFn (row) {
      this.$confirm('是否要指定接单?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        appointFlow({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.jiedanFlag = 1
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      flowOffList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '待报价'
        case 1101:
          return '已报价'
        case 1201:
          return '己中签'
        case 1202:
          return '已结束'
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
